/**
 * @param {object} el
 * @returns {boolean}
 */
function isElementInViewport (el) {
  if (typeof window === 'undefined' || !el) return true

  const rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

module.exports = { isElementInViewport }
